import {Component, OnInit} from '@angular/core';
import {TransportationService} from '../api/transportation.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss']
})
export class SegmentComponent implements OnInit {
  public segments = [];

  constructor(private transportationService: TransportationService, private http: HttpClient) {
    this.showSegments();
  }


  ngOnInit() {
  }

  private showSegments() {
    this.transportationService.getAllTransportations().subscribe(
      res => this.segments = res);
    console.log('segment.component: segments', this.segments);

  }
}
